import { makeStyles } from '@material-ui/core';

const useNeoWrapperDefaultTopBarStyles = makeStyles((theme) => ({
  hamburgerIcon: {
    color: 'var(--white)',
    '& .MuiSvgIcon-root': {
      color: 'var(--white)'
    }
  },
  arrowBackIcon: {
    color: 'var(--white)',
    fontSize: '38px',
    '&:hover': {
      cursor: 'pointer'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px'
    }
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 76,
    padding: 24,
    width: '100%',
    boxSizing: 'border-box'
  },
  title: {
    fontFamily: 'var(--font-family-base)',
    color: 'var(--white)',
    lineHeight: '56px',
    fontWeight: 500,
    margin: '24px 0px 24px 0'
  },
  inviteWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  inviteTooltip: {
    position: 'absolute',
    top: 44,
    right: 0,
    width: 275,
    padding: 16,
    backgroundColor: '#1F6F8B',
    color: '#FFFFFF',
    borderRadius: 8,
    boxShadow: '0px 6px 16px rgba(0,0,0,0.2)',
    zIndex: 1400,
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  gotIt: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    color: '#FFFFFF',
    cursor: 'pointer',
    alignSelf: 'flex-end',
    textAlign: 'center'
  },
  tooltipText: {
    width: 243,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    color: '#FFFFFF'
  },
  inviteTooltipArrow: {
    position: 'absolute',
    top: -8,
    right: 24,
    width: 0,
    height: 0,
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderBottom: '8px solid #1F6F8B'
}
}));

export default useNeoWrapperDefaultTopBarStyles;
